import React from "react";
import {
  ListItem,
  ListItemText,
  Divider,
  useTheme,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";

import { Family } from "../../interfaces/DTO/crm/family";
import { Contact } from "../../interfaces/DTO/crm/contact";
import CustomAvatar from "./CustomAvatar";
import { formatName } from "../../utils/namesFormater";
import { formatEntityFilterCategory, EntityFilterCategory, colorEntityFilterCategory, iconEntityFilterCategory } from "../../utils/featuresFormatter";
import { DataAccessTypeEnum } from "../../interfaces/DTO/features/ShareContact";
import { Share } from "@mui/icons-material";
import { calculateAvatarStyle } from "../../utils/avatarStyleCalculator";

interface UserFamilyListItemProps {
  item: Contact | Family;
  isSelected: boolean;
  onSelect: (isContact: boolean, itemId: number, itemName: string) => void;
}

const UserFamilyListItem: React.FC<UserFamilyListItemProps> = ({
  item,
  isSelected,
  onSelect,
}) => {
  const theme = useTheme();

  const isContact = "first_name" in item;
  const itemId = isContact ? (item as Contact).id! : (item as Family).id;
  const itemName = isContact ? formatName(item as Contact) : (item as Family).name;
  const contactType = isContact ? (item as Contact).data_access_type : undefined;
  const emailOrLabel = isContact
    ? (item as Contact).email || (item as Contact).phone || ""
    : "משפחה";


    const showShareIcon =
      isContact &&
      [
        DataAccessTypeEnum.SHARED_IN,
        DataAccessTypeEnum.SHARED_IN_ANON,
        DataAccessTypeEnum.DEMO,
        // DataAccessTypeEnum.SHARED_OUT_DEMO_ANON,
        // DataAccessTypeEnum.SHARED_OUT,
        // DataAccessTypeEnum.SHARED_OUT_ANON,
      ].includes(contactType!);

    // חישוב סגנון Avatar לפי תקופת דיווח וגיל
    const avatarStyle = isContact
      ? calculateAvatarStyle(item as Contact)
      : { backgroundColor: theme.palette.family.main, color: "#FFFFFF" };

  const handleClick = () => {
   // console.log("🟡 UserFamilyListItem.handleClick");
   // console.log("   itemId:", itemId, "isContact:", isContact);

    // רק קריאה ל-onSelect - handleSelect יטפל בעדכון ה-URL
    onSelect(isContact, itemId, itemName);
    // console.log("   ✅ קריאה ל-onSelect הושלמה (handleSelect יעדכן את ה-URL)");
  };

  return (
    <>
      <ListItem
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          paddingY: 1,
          cursor: "pointer",
          backgroundColor: isSelected
            ? theme.palette.userList?.selected
            : "transparent",
          "&:hover": {
            backgroundColor: isSelected
              ? theme.palette.userList.selected
              : theme.palette.userList.hover,
          },
        }}
      >
      <CustomAvatar
        item={item}
        isUser={isContact}
        userColor={avatarStyle.backgroundColor}
        familyColor={theme.palette.family.main}
        customTextColor={avatarStyle.color}
        customBorder={avatarStyle.border}
      />

        <ListItemText
          primary={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography sx={{fontSize:"1.1em",fontWeight:"500"}}>{itemName}</Typography>
              {showShareIcon && (
                <Tooltip title="לקוח זה שותף עם חברה אחרת">
                  <Share fontSize="small" color="action" />
                </Tooltip>
              )}
              {isContact && item.has_question && (
                <Tooltip title={formatEntityFilterCategory(EntityFilterCategory.HasQuestion)}>
                  <span style={{ color: colorEntityFilterCategory(EntityFilterCategory.HasQuestion) }}>
                    {iconEntityFilterCategory(EntityFilterCategory.HasQuestion)}
                  </span>
                </Tooltip>
              )}
              {isContact && item.requires_attention && (
                <Tooltip title={formatEntityFilterCategory(EntityFilterCategory.RequiresAttention)}>
                  <span style={{ color: colorEntityFilterCategory(EntityFilterCategory.RequiresAttention) }}>
                    {iconEntityFilterCategory(EntityFilterCategory.RequiresAttention)}
                  </span>
                </Tooltip>
              )}
              {isContact && (item.favorites_rank ?? 0) > 0 && (
                <Tooltip title={formatEntityFilterCategory(EntityFilterCategory.Favorite)}>
                  <span style={{ color: colorEntityFilterCategory(EntityFilterCategory.Favorite) }}>
                    {iconEntityFilterCategory(EntityFilterCategory.Favorite)}
                  </span>
                </Tooltip>
              )}
            </Box>
          }
          secondary={ <Typography sx={{color:"#999",fontSize:"0.94em"}}>{emailOrLabel}</Typography>}
        />
      </ListItem>
      <Divider sx={{ marginLeft: 8 }} />
    </>
  );
};

export default UserFamilyListItem;
